import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|History|Credential Agreements|Latest Agreement Modal|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.CredentialAgreement,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateLatestAgreementModal';
export type SPCandidateLatestAgreementModalLocNames =
	| `${LocNameStart}Title`
	| `${LocNameStart}ButtonClose`;

export const spCandidateLatestAgreementModalLocs: LocDefs<SPCandidateLatestAgreementModalLocNames> =
	{
		SPCandidateLatestAgreementModalTitle: {
			defaultValue: 'Latest Agreement',
			description: 'Modal Title',
			displayPath: `${pathStart}Modal Title`,
			displayType: 'Title',
			legacyName:
				'Credential.Agreement/Candidates.CredentialAgreements.Title.LatestAgreement',
			...sharedProperties,
		},
		SPCandidateLatestAgreementModalButtonClose: {
			defaultValue: 'Close',
			description: 'Close Button',
			displayPath: `${pathStart}Close`,
			displayType: 'Button',
			legacyName:
				'Credential.Agreement/Candidates.CredentialAgreements.Button.CloseAgreement',
			...sharedProperties,
		},
	};

export type SPCandidateLatestAgreementModalLocType =
	LocMap<SPCandidateLatestAgreementModalLocNames>;
